import { PaymentAccountReducer } from '@portal/models/reducers';
import {
  setHeader,
  removeHeader,
} from '@portal/repositories/securitySdkConfig';
import { SET_PAYMENT_ACCOUNT_ID } from './actionTypes';
import { AccountActions } from '.';
import { StorageItems } from '@portal/services/storage';

export type SetPayloadPaymentAccountIdType = {
  type: string;
  payload: PaymentAccountReducer['selectedPaymentAccount'];
};

const setPaymentAccount = (
  payload: SetPayloadPaymentAccountIdType['payload']
) => ({
  type: SET_PAYMENT_ACCOUNT_ID,
  payload,
});

export const changePaymentAccount =
  (paymentAccount: SetPayloadPaymentAccountIdType['payload']) =>
  async (dispatch) => {
    if (paymentAccount && paymentAccount.id) {
      setHeader(StorageItems.PAYMENT_ACCOUNT_ID, paymentAccount.id, 'session');
      dispatch(setPaymentAccount(paymentAccount));
      dispatch(AccountActions.getUserBalance(paymentAccount.id));
      dispatch(AccountActions.getUserConfig(paymentAccount.id));
    } else {
      removeHeader(StorageItems.PAYMENT_ACCOUNT_ID, 'session');
    }
  };
